document.addEventListener('DOMContentLoaded', function(){
    const bodyToggle = document.querySelector('body');
    const menuToggle = document.querySelector('.navigation-toggle');
    const menuClose = document.querySelector('.navigation-mobile .navigation-toggle-close');

    menuToggle.addEventListener('click', (e) => {
        console.log('test');
        bodyToggle.classList.toggle('mobile-nav-open');
        bodyToggle.classList.toggle('lock-scroll');
    });

    menuClose.addEventListener('click', (e) => {
        bodyToggle.classList.toggle('mobile-nav-open');
        bodyToggle.classList.toggle('lock-scroll');
    });
});
